import React from 'react'

import './about.css';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import HNB from '../assests/hnblogo.png';
import hnbinfo from '../assests/hb-info.png';

function About() {
   
  return (
    <div className='aboutsection'>
        
        {/* -- introduction -- */}
        <div className="introabout">
            <p className="abouttitle">Introduction</p>
            <p className="subabout">Home <span><ArrowForwardIosIcon className='spanicon' /><ArrowForwardIosIcon className='spanicon1'/></span> About</p>
        </div>



        <div className="section2">
            <div className="content1">
                <p className="aboutcontentone">
                <strong>H & B Computer Education </strong>Mission is to train all the interested candidates 
                who would like to make career or grow business with the help of Hardware 
                Training, Networking Training, Software Training, Digital marketing Training. 
                We would also like to create an online session in regional language so, that candidates 
                who don’t have proficiency in English can also understand this course and take maximum 
                benefits out of this course as well.<br/>
                <br/><br/><br/><br/>
                <strong>H & B InfoTech</strong> is an Information Technology Solutions and Services providing Company, 
                Combining unparalleled experience, comprehensive capabilities across all industries and 
                business functions. H & B InfoTech collaborates with clients to help them to become 
                high-performance businesses.
                Our “high performance business” strategy builds on our expertise in Technology, 
                Solutions and Services to help clients perform at the highest levels so they can create
                sustainable value for their customers. Using our industry knowledge, service-offering 
                expertise and technology capabilities, we identify new business and technology trends 
                and develop solutions to help clients.
                </p>

                <div className="aboutimgsection">
                    <img src={HNB}  width="200" height="200" className='imgoneabout' alt="hnb computer education" />
                    <img src={hnbinfo} width="200" height="200" className='imgoneabout' alt="hnb infoTech" />
                </div>

            </div>
        </div>


        
        {/* -- section 3 -- */}
        <div className="aboutsectionthree">
            <div className="abouttitlestory">Our Story</div>
            <p className="aboutsub">
            <strong>H & B Computer Education</strong> established in 2008, Today H & B Computer Education is 
            one of the leading Training Institute in Ahmadabad, Gujarat, India. H & B 
            Computer Education is one of the largest recruitment and training companies 
            specializing in Permanent and Contract staffing solutions across all IT functions. 
            We provide innovative and customized solutions that aids companies find talent and 
            close their positions quickly.
            <br/><br/><br/>
            <strong>Why H & B Computer Education?</strong><br/>
            Live Project Training<br/>
            Training Material<br/>
            Job Guarantee (100% Placement)<br/>
            Our students work on all over India with reputed companies. Below is few company list where our student currently working<br/>
            – WIPRO<br/>
            – TCS<br/>
            – INFOSYS<br/>
            – Einfochips<br/>
            – Elitecore Technology<br/>
            </p>
        </div>




        {/* -- section 4 form -- */}
        <section class="contact" />
              <div class="cont container">
                  <div class="contact-text">
                      <p>Drop your inquiry here and our experts will get back to you.</p>
                      <h6>Address</h6>
                      <p class="address">
                      35, 2nd floor, Vinay arcade,Nr. Kamal Choice, Opp. Maninagar Rly. Station,Ahmedabad, Gujarat
                      </p>
                      <h6>Email</h6>
                      <p class="mail">info@hnbinfo.com</p>
                  </div>
                  <div class="contact-form">
                      <form/>
                          <label for="name" className='secname'>Name :</label>
                          <input type="text" name="name" id="name" required/><br/>
                              <label for="email" className='secname1'>Email :</label>
                              <input type="email" name="email" id="email" required/><br/>
                                  <label for="message" className='secname'>Message :</label>
                                  <textarea name="message" id="message" cols="30" rows="5" required></textarea><br/>
                                  <input type="submit" className='secbutton' value="submit"/>
                                  <form />
                              </div>
                          </div>
        <section />



        </div>
  )
}

export default About